module.exports = __webpack_public_path__ + "images/giftTree/recurrence.fe771c9f0df59e03a93efb63dabce8b7.png";